import { useState } from 'react';

import { getQuickQuote } from '@/apiCalls/matchingEngine';
import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';

import { TDContactDetails } from './TDContactDetails';
import { TDOcrSummaryButtons } from './TDOcrSummaryButtons';
import { TDPersonalInformation } from './TDPersonalInformation';

export const testId = 'TestDriveOcrSummary';

export function TestDriveOcrSummary(): JSX.Element {
    // ***** Local State *****
    const [showErrors, setShowErrors] = useState(false);

    // ***** CONSTANTS *****
    const baseId = 'screen-TestDriveOcrSummary';

    getQuickQuote();

    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <ProgressBar />
                <DisplayHeading
                    title='Details summary'
                    infoText="Here's what we've got so far. Something missing or not quite right? Select the box or the Edit button to fix it up."
                />
                <TDContactDetails baseId={baseId} showErrors={showErrors} />
                <TDPersonalInformation
                    baseId={baseId}
                    showErrors={showErrors}
                />
                <TDOcrSummaryButtons
                    baseId={baseId}
                    setShowErrors={setShowErrors}
                />
            </DisplayComponent>
        </div>
    );
}
